<template>
  <section id="userIndex">
    <alert :data="errorData" :active="activeAlert" :colorAlert="colorAlert" @dialog:change="closeAlert" />

    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="12" md="auto">
          <BtnRegisterClients />
          <UpdateClient :data="clientInfo" :updateClient="updateActive" @dialog:change="eventdialog" />
        </v-col>

        <v-col cols="12" md="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="allExternalCLients"
        :search="search"
        :server-items-length="totalItems"
        hide-default-footer
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium"> </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
                  <v-img v-if="item.url_image" :src="item.url_image" alt="Avatar del usuario"></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip color="transparent" small @click="changeStatus(item)">
            <v-icon left small :color="item.status === 1 ? 'success' : 'error'">mdi-radiobox-marked</v-icon>
            {{ item.status ? "Habilitado" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="ShowUsers(item)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover> -->

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="editClient(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="deleteClient(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <v-row justify="end">
      <v-col cols="12" md="auto" class="v-data-footer">
        <!-- <v-row dense align="center"> -->
        <!-- <v-col class="v-data-footer__select">
          <span>Filas por página:</span>
          <v-select
            class="ml-3"
            :items="[15, 50, 100, 150]"
            v-model="options.itemsPerPage"
            @change="GetExternalClients"
            style="width: 60px"
            hide-details
          >
          </v-select>
        </v-col> -->

        <v-col>
          <v-pagination circle color="primary" v-model="page" :length="pageCount" total-visible="3"></v-pagination>
        </v-col>
        <!-- </v-row> -->
      </v-col>
    </v-row>

    <!-- <v-dialog v-model="dialog" max-width="750">
      <v-data-table :headers="UsersHeaders" :items="UserInfo">
        <template v-slot:item.status="{ item }">
          <v-icon
            left
            small
            :color="
              item.status === 1
                ? 'success'
                : item.status === 3
                ? 'warning'
                : 'error'
            "
            >mdi-radiobox-marked</v-icon
          >
          {{
            item.status == 1
              ? "Habilitado"
              : item.status == 3
              ? "Bloqueado"
              : "Inactivo"
          }}
        </template>
      </v-data-table>
    </v-dialog> -->
  </section>
</template>

<script>
import { mapState } from "vuex";

import BtnRegisterClients from "@/components/ExternalClients/Register.vue";
import UpdateClient from "@/components/ExternalClients/EditClient.vue";
import alert from "../Utils/Alert";

export default {
  components: {
    BtnRegisterClients,
    UpdateClient,
    alert,
  },
  data() {
    return {
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: false,
          value: "name",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Dirección IP",
          value: "ip",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Dirección IPQA",
          value: "ip_qa",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Ciente",
          value: "client.name",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Creado",
          value: "created_at",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      UsersHeaders: [
        {
          text: "Nombre",
          align: "left",
          sortable: false,
          value: "name",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Correo",
          value: "email",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "20%",
        },
      ],
      // For pagination
      totalItems: 0,
      page: 1,
      // End for pagination
      search: "",
      data: [],
      UserInfo: [],
      dialogTableVisible: false,
      dialog: false,
      clientInfo: "",
      updateActive: false,
      errorData: "",
      activeAlert: "",
      colorAlert: "",
    };
  },

  computed: {
    ...mapState("clients", ["allExternalCLients"]),
  },

  watch: {
    page() {
      this.GetExternalClients();
    },
  },

  async created() {
    await this.GetExternalClients();
  },

  methods: {
    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    async GetExternalClients() {
      try {
        const params = {
          page: this.page,
          // itemPerPage: itemsPerPage,
        };

        const res = await this.$store.dispatch("clients/SHOW_EXTERNAL_CLIENTS", params);
        this.totalItems = res.total;
        this.pageCount = res.last_page;
      } catch (error) {
        // console.log(error);
        this.$snotify.error("No se pudo obtener listado de clientes externos.", "¡Error!");
      }
    },
    ShowUsers(users) {
      // console.log(users);
      this.dialog = true;
      this.UserInfo = users.user_relation;
      // console.log(this.UserInfo);
    },
    editClient(client) {
      // this.clientInfo = client;
      this.clientInfo = {
        id: client.id,
        name: client.name,
        user: client.user,
        email: client.email,
        ip: client.ip,
        nameBd: client.nameBd,
        port: client.port,
        ip_sokect: client.ip_sokect,
        user_sokect: client.user_sokect,
        clave_sokect: client.clave_sokect,
        port_sokect: client.port_sokect,
      };
      this.updateActive = true;
      // console.log(this.clientInfo);
    },
    async deleteClient(client) {
      this.clientInfo = client;
      const response = await this.$store.dispatch("clients/DELETE_EXTERNAL_CLIENTS", {
        id: client.id,
      });
      this.errorData = response.data;
      this.activeAlert = true;
      this.colorAlert = "blue";
      // console.log(response);
    },
    eventdialog(message) {
      this.updateActive = false;
      if (message !== "cerrar") {
        this.errorData = "Cliente Actualizado";
        this.activeAlert = true;
        this.colorAlert = "blue";
      }
    },
    closeAlert() {
      this.activeAlert = false;
    },
    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        await this.$store.dispatch("clients/CHANGE_STATUS", {
          id: value.id,
        });
      }
    },
  },
};
</script>
